import { atom } from 'jotai'

export const dispatchBoardElementAtom = atom<HTMLDivElement | null>(null)

dispatchBoardElementAtom.debugLabel = 'dispatchBoardElementAtom'
